<template>
    <img src="/vue/images/facebook.png" @click="openFbLoginDialog">
</template>
<script>
    window.fbAsyncInit = function () {
        FB.init({
            appId: "422289938612780",
            cookie: true, // enable cookies to allow the server to access
            // the session
            xfbml: true, // parse social plugins on this page
            version: "v3.2" // use graph api version 2.8
        });
        FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    import functions from "./functions.js";

    export default {
        mixins: [functions],
        methods: {
            openFbLoginDialog() {
                FB.login(this.checkLoginState, {scope: "email"});
            },
            checkLoginState(response) {
                if (response.status === "connected") {
                    console.log(454);
                    FB.api(
                        "/me",
                        {
                            access_token: response.authResponse.access_token,
                            fields:
                                "first_name,last_name,id,picture.width(2000).height(2000),email,gender"
                        },
                        profile => {
                            if (profile.id) {
                                this.socLogin(
                                    profile.first_name,
                                    profile.last_name,
                                    profile.id,
                                    profile.picture.data.url,
                                    profile.email,
                                    "Facebook"
                                );
                            }
                        }
                    );
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/social/facebook.vue